import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-card-basic',
    templateUrl: './card-basic.component.html',
    styleUrls: ['./card-basic.component.scss']
})
export class CardBasicComponent {

    @Input() public icon: string;
    @Input() public title: string;
    @Input() public accessible_text: string;
    @Output() public buttonEvent = new EventEmitter<string>();

}
